import React from 'react'
import {
  compose,
  withHandlers,
  withState,
} from '@nobia/zeus-components/lib/recompose'
import styled, { ifProp, rem, theme } from '@nobia/zeus-components/lib/styled'
import { Paragraph } from '@nobia/zeus-components/lib/text'
import withClickOutside from '@nobia/zeus-components/lib/withClickOutside'
import { Icon } from '@nobia/zeus-components/lib/icons'

const HeaderItem = styled(Paragraph)`
  text-align: left;
  padding: ${theme('dropdown.padding')};
  background: ${theme('dropdown.backgroundColor')};
  margin: 0;
  color: ${theme('dropdown.color')};
  font-size: 16px;
  font-weight: ${theme('dropdown.fontWeight')};
`
const Chevron = styled(Icon)`
  margin-top: 3px;
  > svg {
    color: ${theme('colors.darkBlue')};
  }
`
const ListItemWrapper = styled.li`
  cursor: pointer;
  width: 100%;
  border-radius: ${theme('dropdown.borderRadius')};
  min-width: ${rem(180)};
  border: 1px solid ${theme('dropdown.borderColors')};
  margin-bottom: ${theme('grid.gutter') / 2};
  list-style-type: none;

  ${(props) => props.theme.media.max.sm`
    border-radius: ${ifProp(
      'expanded',
      theme('dropdown.open.borderRadius'),
      theme('dropdown.closed.borderRadius')
    )};
  `};
`
const ListItem = styled.div``
const DropDown = styled.ul`
  text-align: left;
  width: 100%;
  padding-left: 0;
  border-top: none;
  background: white;
  list-style-type: none;
  &::-webkit-scrollbar {
    display: none;
  }
`
const DropDownItemWrapper = styled.div`
  max-height: ${rem(250)};
  overflow: auto;
  border: 1px solid ${theme('colors.border')};
  border-radius: ${theme('dropdown.panel.borderRadius')};
  border-width: 0 1px 1px 1px;
  overflow-x: hidden;
  margin-left: -1px;
  width: calc(100% + 2px);
`
const DropDownItem = styled.li`
  color: ${theme('dropdown.color')};
  cursor: ${ifProp('enabled', 'pointer', 'default')};
  border-radius: 3px;
  background: ${ifProp(
    'selected',
    theme('colors.border'),
    theme('colors.backgroundPrimary')
  )};
  list-style-type: none;
  padding: ${rem(10)} ${rem(16)};
`
const StyledIcon = styled.span`
  float: right;
  margin-top: 3px;
  pointer-events: none;
  > svg {
    pointer-events: none;
  }
`
const isSelected = (selected, value) => {
  if (selected === value) {
    return true
  }
  const parts = (selected && selected.split('+')) || []
  let match = false
  parts.forEach((part) => {
    if (part === value) {
      match = true
    }
  })
  return match
}
type Props = {
  options: Array<{
    value: string,
    enabled: boolean,
  }>,
  select: (string) => void,
  selected: string,
  children: (string) => Node,
  expanded: boolean,
  toggle: () => void,
  header: (string) => Node,
}
const DropdownMagnet = ({
  options,
  selected,
  header,
  children,
  select,
  expanded,
  toggle,
}: Props) => (
  <ListItemWrapper
    onClick={toggle}
    expanded={expanded}
    data-cy="DropdownMagnet"
  >
    <ListItem expanded={expanded}>
      <HeaderItem>
        {header(selected)}
        <StyledIcon onClick={toggle}>
          {expanded ? (
            <Chevron type="chevron-up" width={15} height={15} />
          ) : (
            <Chevron type="chevron-down" width={15} height={15} />
          )}{' '}
        </StyledIcon>
      </HeaderItem>
      {expanded && (
        <DropDownItemWrapper>
          <DropDown>
            {options.map((option) => (
              <DropDownItem
                key={option.value}
                enabled={option.enabled}
                selected={isSelected(selected, option.value)}
                onClick={() => option.enabled && select(option.value)}
              >
                {children(option.value)}
              </DropDownItem>
            ))}
          </DropDown>
        </DropDownItemWrapper>
      )}
    </ListItem>
  </ListItemWrapper>
)
DropdownMagnet.defaultProps = {
  selected: null,
  children: (value) => value,
  header: (value) => value,
}
const enhance = compose(
  withState('expanded', 'setExpanded', false),
  withHandlers({
    toggle:
      ({ setExpanded }) =>
      () =>
        setExpanded((expanded) => !expanded),
  }),
  withClickOutside(({ setExpanded }) => setExpanded(false))
)
export default enhance(DropdownMagnet)
